// Example: src/views/GoogleAuthError.vue
<template>
  <div>
    <h2>Google Authentication Failed</h2>
    <p v-if="errorMessage">Error: {{ errorMessage }}</p>
    <p>Please try logging in again or contact support.</p>
    <router-link to="/login">Go to Login</router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errorMessage: ''
    };
  },
  created() {
    this.errorMessage = this.$route.query.error_message || 'An unknown error occurred.';
  }
};
</script>